import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ColorSF2 from '../../styles/common/ColorSF2';
import cancelImg from '../../images/common/close.svg';

const BUTTON_SIZE = '20px';

const HeaderContainer = styled.div`
  min-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  color: ${ColorSF2.black};
  font-weight: bold;
  width: auto;
  padding: 0 15px;
`;

const CloseButtonImage = styled.img`
  width: ${BUTTON_SIZE};
  height: ${BUTTON_SIZE};
`;

/**
 * 詳細ページのヘッダーコンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.title - ヘッダーのタイトル
 * @param {Function} props.onBack - 閉じるボタンをクリックしたときのコールバック
 * @returns {ReactElement} ヘッダーコンポーネント
 */
const DetailHeader = ({ title, onBack }) => (
  <HeaderContainer id="headerContainer">
    <div>{title}</div>
    <CloseButtonImage
      id="closeButton"
      role="presentation"
      src={cancelImg}
      alt="backButton"
      className="button"
      onClick={onBack}
    />
  </HeaderContainer>
);

DetailHeader.propTypes = {
  title: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default DetailHeader;
